
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sch-test",
      function () {
        return require("private-next-pages/sch-test/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sch-test"])
      });
    }
  